module.exports = __webpack_public_path__ + "static/icingdeath-mtg_afr-fdcb690fdff01385a5e154e041f0154b.jpg";